import React from 'react'
import { tv } from 'tailwind-variants'

const spinner = tv({
  base: 'animate-spin shrink-0 rounded-full bg-transparent border-4 border-divider-subtle border-t-divider-strong h-[50px] w-[50px]',
  variants: {
    size: {
      small: 'h-5 w-5',
      medium: 'h-8 w-8',
      large: 'h-[50px] w-[50px]'
    }
  }
})

const Spinner = ({
  size = 'large',
  className = '',
  ...props
}: {
  size?: 'small' | 'medium' | 'large'
  className?: string
  [key: string]: any
}) => {
  return <div className={spinner({ size, class: className })} {...props} />
}

export default Spinner
